import type { Copy } from "../types";

export const hi: Copy = {
    seo: {
      title: "कार आयु कैलकुलेटर | निर्माण वर्ष और महीना से वाहन आयु जांचें",
      description:
        "वाहन के निर्माण वर्ष और वैकल्पिक महीने से उसकी सटीक आयु जांचें। वर्षों, महीनों, दिनों, कुल दिनों और मील के पत्थर की जानकारी एक ही साफ़ कैलकुलेटर में देखें।",
      keywords: [
        "कार आयु कैलकुलेटर",
        "वाहन आयु कैलकुलेटर",
        "कार निर्माण वर्ष कैलकुलेटर",
        "वाहन निर्माण महीना कैलकुलेटर",
        "गाड़ी कितनी पुरानी है",
        "कार आयु वर्ष से",
        "वाहन आयु जांच",
        "आरसी आयु कैलकुलेटर",
        "कार आयु महीना से",
        "वाहन तिथि कैलकुलेटर",
        "एमपरिवहन विकल्प",
        "परिवहन विकल्प",
        "आरटीओ वाहन आयु कैलकुलेटर",
        "कार पंजीकरण आयु जांच",
        "वाहन पंजीकरण आयु",
      ],
      faq: [
        {
          question: "यह कैलकुलेटर क्या करता है?",
          answer:
            "यह चुने गए निर्माण वर्ष और वैकल्पिक महीने से वाहन की सटीक आयु निकालता है और वर्षों, महीनों, दिनों तथा मील के पत्थर की जानकारी दिखाता है।",
        },
        {
          question: "वैकल्पिक महीना क्यों है?",
          answer:
            "महीना जोड़ने से आयु की गणना अधिक सटीक होती है। अगर आप महीना नहीं चुनते, तो जनवरी माना जाता है।",
        },
        {
          question: "क्या मैं भविष्य का वर्ष या महीना चुन सकता हूँ?",
          answer:
            "नहीं। भविष्य के वर्ष रोके गए हैं और जब चुना गया वर्ष वर्तमान वर्ष होता है, तब भविष्य के महीने उपलब्ध नहीं होते।",
        },
      ],
    },
    headerTagline: "वाहन उपयोगिता",
    headerTitle: "कार आयु कैलकुलेटर",
    reset: "रीसेट",
    switchToLight: "हल्का मोड",
    switchToDark: "गहरा मोड",
    languageLabel: "भाषा",
    languageEnglish: "अंग्रेज़ी",
    languageHindi: "हिंदी",
    heroEyebrow: "कार की उम्र, साफ़ तरीके से",
    heroTitle: "वाहन आयु के लिए एक साफ़ तारीख़ उपकरण।",
    heroDescription:
      "निर्माण वर्ष चुनें। अधिक सटीक परिणाम के लिए ही महीना जोड़ें।",
    yearSelectLabel: "निर्माण वर्ष",
    monthSelectLabel: "निर्माण महीना",
    includeMonthLabel: "अधिक सटीकता के लिए विशिष्ट महीना शामिल करें",
    includeMonthNote:
      "यदि आप महीना शामिल नहीं करते, तो गणना के लिए जनवरी माना जाएगा।",
    yearOnlyBadge: "केवल वर्ष",
    yearMonthBadge: "वर्ष + महीना",
    yearPlaceholder: "वर्ष चुनें",
    monthPlaceholder: "महीना चुनें",
    inputTitle: "निर्माण वर्ष",
    inputLabel: "निर्माण वर्ष",
    blockedDateNote: "भविष्य के वर्ष उपलब्ध नहीं हैं।",
    result: "परिणाम",
    vehicleAgeLead: "आपका वाहन है",
    asOfToday: "आज तक",
    years: "वर्ष",
    months: "महीने",
    days: "दिन",
    totalDays: (count) => `${count.toLocaleString("en-IN")} कुल दिन पुराना`,
    ageLabels: {
      almostNew: "लगभग नई",
      modern: "आधुनिक",
      mature: "परिपक्व",
      classic: "क्लासिक",
    },
    estimatedValue: {
      high: "उच्च पुनर्विक्रय संभावना",
      healthy: "मजबूत मूल्य संरक्षण",
      moderate: "मध्यम मूल्यह्रास",
      collector: "संग्रहकर्ता रुचि बढ़ सकती है",
    },
    maintenanceTitle: "रखरखाव",
    maintenance: {
      routine: "नियमित सर्विस और ओईएम देखभाल",
      watch: "ब्रेक, द्रव और टायर पर नज़र रखें",
      plan: "घिसावट वाले हिस्सों और जांच की योजना बनाएं",
      specialized: "विशेष रखरखाव उपयोगी हो जाता है",
    },
    registrationTitle: "पंजीकरण",
    registration: {
      collector: "कुछ क्षेत्रों में संग्राहक-शैली उपचार मिल सकता है",
      classic: "कुछ क्षेत्रों में क्लासिक-कार शैली पंजीकरण लागू हो सकता है",
      standard: "मानक नवीनीकरण और क्षेत्रीय जांच की उम्मीद करें",
      regular: "आमतौर पर नियमित पंजीकरण लागू होता है",
    },
    upcomingMilestoneTitle: "अगला मील का पत्थर",
    milestoneTimelineTitle: "मील का पत्थर समयरेखा",
    milestoneRemaining: ({ label, days }) => `${label}: ${days.toLocaleString("hi-IN")} दिन बाकी`,
    reached: "पूर्ण",
    upcoming: "आने वाला",
    allMilestonesReachedTitle: "सभी सूचीबद्ध मील के पत्थर पूरे हो चुके हैं",
    allMilestonesReachedBody:
      "इस वाहन ने ऐप में दिखाया गया मील का पत्थर दायरा पार कर लिया है।",
    copySummary: "सारांश कॉपी करें",
    shareResult: "परिणाम साझा करें",
    resetMessage: "कैलकुलेटर रीसेट हो गया",
    summaryCopied: "सारांश क्लिपबोर्ड में कॉपी हो गया",
    clipboardFailed: "क्लिपबोर्ड तक पहुंच नहीं मिली",
    emptyTitle: "पूरा विवरण देखने के लिए निर्माण वर्ष चुनें",
    emptyDescription:
      "वर्ष चुनते ही सटीक आयु, कुल दिन, रखरखाव नोट, क्लासिक स्थिति और मील के पत्थर का समय दिखाई देगा।",
    shareTitle: "कार आयु कैलकुलेटर",
    summary: ({ label, years, months, days, asOf }) =>
      `मेरी कार का निर्माण ${label} में हुआ था और ${asOf} तक इसकी उम्र ${years} वर्ष, ${months} महीने और ${days} दिन है।`,
    milestones: {
      1: { label: "पहला वर्ष", note: "वारंटी और सर्विस योजना के लिए उपयोगी।" },
      3: { label: "तीन वर्ष", note: "पुनर्विक्रय और मूल्य बदलाव का सामान्य समय।" },
      5: { label: "पाँच वर्ष", note: "रखरखाव बजट पर गंभीरता से सोचने का अच्छा समय।" },
      10: { label: "दस वर्ष", note: "पुराने हिस्सों पर अधिक ध्यान दें।" },
      15: { label: "पंद्रह वर्ष", note: "कई क्षेत्रों में क्लासिक-शैली उपचार शुरू होता है।" },
      25: { label: "पच्चीस वर्ष", note: "कुछ बाजारों में संग्राहक और आयात के लिए अनुकूल।" },
    },
  };
